var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.groupClass},[(_vm.title)?_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("title-extra")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }